import React from 'react';
import PropTypes from 'prop-types';
import { datadogRum } from '@datadog/browser-rum';

class ConfirmationPageErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    datadogRum.addError(error, {
      component: 'ConfirmationPage',
      errorType: '526ez-v2-confirmation-review-render-failure',
      componentStack: errorInfo?.componentStack,
    });
  }

  render() {
    if (this.state.hasError) {
      return null;
    }

    return this.props.children;
  }
}

ConfirmationPageErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ConfirmationPageErrorBoundary;
